import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isodate'
})
export class IsodatePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    let rv = value;
    if ('string' === typeof(value)) {
      rv = new Date(value);
    }
    else if ('object' === typeof(value)) {
      rv = new Date(value.$date);
    }

    return rv;
  }
}
